<template>
  <div class="categoryJumbotron">
    <div class="categoryJumbotron__image" :style="{backgroundImage: 'url(' + image + ')'}">
      <div class="categoryJumbotron__image__overlay"></div>
      <div class="categoryJumbotron__image__layer">
          <div class="categoryJumbotron__image__layer__content">
              <h2 v-if="smallTitle" class="subhead bold space">{{smallTitle | capitalizing}}</h2>
              <h1 class="xlarge-title">{{title | capitalizing}}</h1>
              <i class="adx-ic_splash"></i>
              <h6 class="base-font subheader-text">{{ subheader }}</h6>
          </div>
      </div>
    </div>
    <p v-if="description">{{description}}</p>
    <div class="categoryJumbotron__image-mobile" :style="{backgroundImage: 'url(' + imageMobile + ')'}">
      <div class="categoryJumbotron__image__overlay"></div>
      <div class="categoryJumbotron__image__layer">
          <div class="categoryJumbotron__image__layer__content">
              <h2 v-if="smallTitle" class="small-title">{{smallTitle | capitalizing}}</h2>
              <h1 class="xlarge-title">{{title | capitalizing}}</h1>
              <i class="adx-ic_splash"></i>
              <h6 class="base-font subheader-text">{{ subheader }}</h6>
          </div>
      </div>
    </div>
    <p v-if="description">{{description}}</p>
  </div>
</template>

<script>
export default {
  name: 'adx-jumbotron-category',
  props: {
    title: {
      required: false
    },
    image: {
      required: true
    },
    imageMobile: {
      required: true
    },
    color: {
      required: false,
      default: '#ff2d55'
    },
    subheader: {
      required: false,
    },
    description: {
      required: false,
    },
    smallTitle:{
      required: false,
    },
  },
  data() {
    return {
      isMobile: document.documentElement.clientWidth <= 768 ? true : false
    }
  },
  methods: {
    getImage() {
      if (this.isMobile) {
        return this.imageMobile
      } 

      return this.image
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>